import useService from '@core/auth/service/useService';
import axios from '@axios';

const { service } = useService(axios, {});
export default service;
